module.exports = __webpack_public_path__ + "static/media/akrem.b3bb47de.png";